<template lang="pug">
.hello
  .hello-intro
    AppIcon(name="logoHelloTypo").hello-intro-logo.u-mb-sm
    p.hello-intro-desc.u-text-lg.u-mb-sm {{$t('helloDesc')}}
    p.u-text-lg {{$t('date')}}
    img.hello-intro-img(src='https://cdn.baianat.com/static/resources/hello/1.jpg' srcset='https://cdn.baianat.com/static/resources/hello/1.jpg 1x, https://cdn.baianat.com/static/resources/hello/1@2x.jpg 2x')



  .hello-ready.u-mt-md
    AppTitle.u-mb-mi(:title="$t('gathering')")
    .grid.is-tablet-6
      .column.u-mb-sm
        h4 {{$t('launchingVentures')}}
        p {{$t('launchingVenturesDesc')}}
      .column.u-mb-sm
        h4 {{$t('sharingInsights')}}
        p {{$t('ourDiscovers')}}
      .column.u-mb-sm
        h4 {{$t('networkingSpaces')}}
        p {{$t('networkingSpacesDesc')}}
      .column.u-mb-sm
        h4 {{$t('celebration')}}
        p {{$t('celebrationDesc')}}

    .hello-ready-img
      img(src='https://cdn.baianat.com/static/resources/hello/2.png', srcset='https://cdn.baianat.com/static/resources/hellos/2.png 1x, https://cdn.baianat.com/static/resources/hello/2@2x.png 2x')

  .hello-black
    AppTitle.u-mb-mi(:title="$t('newEra')" tag="h2")

    .grid.is-tablet-6.u-mb-md
      .column
        h4 {{$t('networkingSpaces')}}
        p {{$t('networkingSpacesDesc')}}

    .grid.is-desktop-4.is-tablet-6.u-mb-sm
      .column.u-mb-sm(v-for="s,idx in 6")
        .hello-speakers-item
          //- img(:src="`https://randomuser.me/api/portraits/men/${Math.floor((Math.random() * 88) + 1)}.jpg`")
          .hello-speakers-placeholder-img
          .hello-speakers-item-body
            h5.hello-speakers-placeholder-title
            p.hello-speakers-placeholder-desc
    .grid.is-tablet-6.u-mb-md
      .column
        h4 {{$t('innovationTalks')}}
        p {{$t('innovationTalksDesc')}}
    .hello-black-img
      img(src='https://cdn.baianat.com/static/resources/hello/3.png', srcset='https://cdn.baianat.com/static/resources/hello/3.png 1x, https://cdn.baianat.com/static/resources/hello/3@2x.png 2x')


  .hello-footer
    h2.u-mb-sm.u-textCenter {{$t('countdownStarted')}}


    CountDown(:time='14 * 24 * 60 * 60 * 1000')
      template(slot-scope='props')
        .hello-countdown
          .hello-countdown-item
            span {{ props.days }} #[img(src="https://cdn.baianat.com/static/resources/hello/icon-1.png")]
          .hello-countdown-item
            span {{ props.hours }} #[img(src="https://cdn.baianat.com/static/resources/hello/icon-2.png")]
          .hello-countdown-item
            span {{ props.minutes }} #[img(src="https://cdn.baianat.com/static/resources/hello/icon-3.png")]
          .hello-countdown-item
            span {{ props.seconds }} #[img(src="https://cdn.baianat.com/static/resources/hello/icon-4.png")]





    .u-mt-md
    AppTitle.u-mb-sm.u-textCenter(:title="$t('soon')" tag="h2")

    //- .grid.is-center.is-ultrawide-7.is-widescreen-9.is-desktop-10.is-tablet-11
    //-   .column
    //-     .hello-form
    //-       h4.u-textCenter.u-mb-0 Register will open soon.
        //-   TextInput(
        //-     name="name"
        //-     type="text"
        //-     label="Name"
        //-   )
        //-   TextInput(
        //-     name="email"
        //-     type="email"
        //-     label="Email"
        //-   )
        //-   TextInput(
        //-     name="phone"
        //-     type="text"
        //-     label="Phone"
        //-   )
        //-   button.button-link join Event


  .u-mb-md

</template>

<style lang="stylus">
$clMain = #1600ff

div.app.is-hello
  background: $clMain
  color: $clWhite
  overflow: hidden
  overflow: hidden

  &.is-dark
    .header.is-scroll
      background: $clDanger

.hello
  &-intro
    margin-left: -($outerMargin)
    margin-right: -($outerMargin)
    padding: unitRes(250, 300) $outerMargin unitRes(200, 500)
    background: $clDanger
    position: relative
    z-index: 1

    +mq($until: 'tablet')
      margin-left: -($outerMargin-sm)
      margin-right: -($outerMargin-sm)
      padding: unitRes(250, 300) $outerMargin-sm unitRes(200, 500)
      padding-bottom: 0

    &-logo.icon
      width: unitRes(200, 500)
      height: unitRes(50, 130)

    &-img
      position: absolute
      bottom: -1px
      right: 0
      z-index: -1
      max-width: 1400px
      display: block

      +mq($until: 'ultrawide')
        max-width: 1150px

      +mq($until: 'widescreen')
        max-width: 950px

      +mq($until: 'desktop')
        max-width: 630px

      +mq($until: 'tablet')
        position: static

      +mq($until: 'mobile')
        margin-left: -200px

    &-desc
      max-width: unitRes(350, 650)

  &-ready
    &-img
      display: block
      margin-left: -($outerMargin)
      margin-right: -($outerMargin)

      +mq($until: 'tablet')
        margin-left: -($outerMargin-sm)
        margin-right: -($outerMargin-sm)

      img
        display: block

  &-black
    background: $clBlack
    margin-left: -($outerMargin)
    margin-right: -($outerMargin)
    padding: 100px $outerMargin 0
    position: relative
    z-index: 2

    +mq($until: 'tablet')
      margin-left: -($outerMargin-sm)
      margin-right: -($outerMargin-sm)
      padding: 100px $outerMargin-sm 0

    &-img
      margin-left: -($outerMargin)
      margin-right: -($outerMargin)

      +mq($until: 'tablet')
        margin-left: -($outerMargin-sm)
        margin-right: -($outerMargin-sm)

      img
        display: block

  &-speakers
    position: relative
    background: $clBlack
    margin-left: -($outerMargin)
    margin-right: -($outerMargin)
    padding-right: $outerMargin
    padding-left: $outerMargin
    padding-top: $outerMargin

    +mq($until: 'tablet')
      margin-left: -($outerMargin-sm)
      margin-right: -($outerMargin-sm)
      padding-right: $outerMargin-sm
      padding-left: $outerMargin-sm
      padding-top: $outerMargin-sm

    &-img
      margin-left: -($outerMargin)
      margin-right: -($outerMargin)

      +mq($until: 'tablet')
        margin-left: -($outerMargin-sm)
        margin-right: -($outerMargin-sm)

      img
        width: 100%
        display: block
        margin-bottom: -1px

    &-item
      display: flex
      align-items: center

      img
        width: unitRes(60, 140)
        height: unitRes(60, 140)
        border-radius: 20em
        margin-right: unitRes(10, 40)

      &-body
        flex: 1 1 0%

    &-placeholder
      &-img
        width: unitRes(60, 140)
        height: unitRes(60, 140)
        flex: 0 0 unitRes(60, 140)
        border-radius: 20em
        background: #181818
        display: block
        margin-right: unitRes(10, 40)

      &-title
        width: 100%
        height: 20px
        background: #181818
        display: block

      &-desc
        width: 100%
        height: 10px
        background: #181818
        display: block

  &-form
    padding: unitRes(40, 160)
    background: $clWhite
    color: $clBlack

    .input, .multiselect .multiselect__tags
      border-color: $clBlack !important
      color: $clBlack !important

      &:focus
        border-color: $clMain !important

  &-countdown
    text-align: center
    font-size: unitRes(40, 200)
    font-weight: $fontWeight-bold
    display: flex
    align-items: center
    justify-content: space-between
    text-align: center
    user-select: none

    &-item
      width: 25%
      position: relative
      z-index: 2

      img
        position: absolute
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        z-index: -1

        +mq($until: 'ultrawide')
          max-width: 80%

html[lang^='ar']
  .hello-intro-img
    right: auto
    left: 0
    transform: scaleX(-1)
    filter: FlipH

    +mq($until: 'mobile')
      margin-left: 0
      margin-right: -200px

  .hello-ready-img img
    transform: scaleX(-1)
    filter: FlipH
</style>

<script>
import TextInput from '~/components/inputs/TextInput';
import CountDown from '~/components/CountDown';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-hello is-fixedHeader is-whiteHeader is-dark',
    logoText: '__NONE__'
  },
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    TextInput,
    CountDown
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Hello Event",
    "pageDesc":"Hello is Baianat event of the year where we share our journey highlights, insights, partners successes, and projects.",
    "helloDesc":"Every year we welcome the world, again.",
    "date":"Alexandria, Early 2019.",
    "gathering":"Get ready for Baianat |yearly gathering.",
    "launchingVentures":"Launching ventures",
    "launchingVenturesDesc":"Get the first look on Baianat internal projects and ventures. Know its development journey and the hidden concepts behind everyone.",
    "sharingInsights":"Sharing insights",
    "ourDiscovers":"Sharing our discovers, concepts and theories that helped us grow this year hoping to inspire you by adding  a one year of experience to your mind.",
    "networkingSpaces":"Networking Spaces",
    "networkingSpacesDesc":"Engage in meaningful conversations with peers and experts from all over the world. Share your experience and exploit every opportunity to build a network.",
    "celebration":"Fun and Celebration",
    "celebrationDesc":"Party harder in the after hours. Join us while we celebrate with our success partners and friends we made during the day for outside work talks.",
    "newEra":"Celebrate the new era with |us and get a closer look |into our war room.",
    "networkingSpaces":"Networking Spaces",
    "networkingSpacesDesc":"The secrets behind our year growth, how we strategically planned for the business and the new innovations we made in design and development.",
    "innovationTalks":"Innovation talks",
    "innovationTalksDesc":"Attend panel discussions and hear our success partners sharing their stories of growth, failure and things they learned along their business development stages.",
    "countdownStarted":"Countdown started!",
    "soon":"Early bird registration |will be open soon."
  },
  "ar": {
    "pageTitle":"بيانات هيلو",
    "pageDesc":"هيلو هو فعالية نقيمها مرة في العام لنتبادل فيها وجهات نظرنا ورؤيتنا ومشاريعنا وقصص نجاحنا والمشاريع المختلفة التي قمنا بها.",
    "helloDesc":"كل عام نرحب بالعالم من جديد.",
    "date":"الإسكندرية، أوائل عام 2019.",
    "gathering":"كُن على استعداد |لتجمُع بيانات السنوي. ",
    "launchingVentures":"إطلاق مشاريع بيانات",
    "launchingVenturesDesc":"تعرف على أعمال ومشروعات بيانات الداخلية. اعرف رحلات تطور المشروعات والمفاهيم الخفية خلف كل واحد منهم.",
    "sharingInsights":"مساحات للتواصل",
    "ourDiscovers":"انخرط في محادثات ذات مغزى مع أقرانك و الخبراء في المجال من كل مكان في العالم. شارك خبرتك واستغل كل فرصة لبناء شبكتك الاجتماعية.",
    "networkingSpaces":"شارك الرؤى",
    "networkingSpacesDesc":"نشارك الاكتشافات والمفاهيم والنظريات التي ساعدتنا على النمو هذا العام. ولدينا أمل كبير لإلهامك من خلال إضافة عام من الخبرات لعقلك.",
    "celebration":"الاحتفال والتجمعات",
    "celebrationDesc":"الاحتفال يكون أجمل بعد العمل الصعب. انضم إلينا أثناء احتفالنا بشركاء النجاح والأصدقاء الذين اكتسبناهم خلال اليوم من محادثات العمل الخارجية.",
    "newEra":"احتفل بالحقبة الجديدة معنا |وألق نظرة عن قرب على |طريقة عملنا.",
    "networkingSpaces":"التواصل والشبكة الاجتماعية",
    "networkingSpacesDesc":"الأسرار وراء نمونا خلال هذا العام، وكيف خططنا استراتيجيتنا للأعمال التجارية، والابتكارات الجديدة التي حققناها في التصميم والتطوير.",
    "innovationTalks":"محادثات حول الابتكارات والأعمال.",
    "innovationTalksDesc":"تستطيع حضور المناقشات والاستماع إلى قصص شركائنا في النجاح لمعرفة قصص الفشل والنجاح الخاص بهم وما تعلموه منا خلال مراحل تطوير أعمالهم.",
    "countdownStarted":"العد التنازلي!",
    "soon":"سيتم فتح باب |التسجيل قريبًا."
  }
}
</i18n>
